var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6 12.8726L22.425 18.1584C22.6486 18.3096 22.7979 18.5422 22.8382 18.802C22.8784 19.0617 22.8061 19.3259 22.638 19.5331C20.373 22.3593 16.8654 24.0109 13.151 24C7.5307 24.0003 2.66309 20.2558 1.43854 14.99C0.214005 9.72411 2.96062 4.34776 8.04745 2.05342C13.1343 -0.240906 19.1984 1.16147 22.639 5.42784C22.8067 5.63507 22.8787 5.89917 22.8382 6.15868C22.7978 6.4182 22.6485 6.65051 22.425 6.80159L14.6 12.0874C14.4668 12.1772 14.3876 12.3237 14.3876 12.48C14.3876 12.6363 14.4668 12.7827 14.6 12.8726ZM8.651 7.2C8.651 8.26039 9.54643 9.12 10.651 9.12C11.1814 9.12 11.6901 8.91771 12.0652 8.55765C12.4403 8.19757 12.651 7.70921 12.651 7.2C12.651 6.13962 11.7556 5.28 10.651 5.28C9.54643 5.28 8.651 6.13962 8.651 7.2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacman);
export default __webpack_public_path__ + "static/media/pacman.515bb5d9.svg";
export { ForwardRef as ReactComponent };